<app-content-card
  [title]="titleKey() | translateLang"
  [subtitle]="subtitleKey() | translateLang"
  [useIconSlot]="true"
  [iconBackgroundColor]="'#96080b'"
  [backgroundColor]="backgroundColor()">

  <!-- Header icon -->
  <app-icon
    iconSlot
    name="star"
    [size]="24"
    [color]="'white'">
  </app-icon>

  <!-- Browse All link in header right slot -->
  @if (showBrowseAll()) {
    <app-link-out
      rightContent
      [label]="browseAllTextKey() | translateLang"
      [href]="browseAllUrl()"
      (click)="onBrowseAllClick()">
    </app-link-out>
  }

  <!-- Charity list in body -->
  <div class="charity-explorer">
    @if (getVisibleCharities().length > 0) {
      <div class="charity-explorer__list">
        @for (charity of getVisibleCharities(); track charity.organisationUuid; let isLast = $last) {
          <app-charity-row
            [charity]="charity"
            [isLastRow]="isLast"
            (charityClicked)="onCharityClick($event)"
            (giveClicked)="onGiveClick($event)">
          </app-charity-row>
        }
      </div>
    } @else {
      <div class="charity-explorer__empty">
        <p class="charity-explorer__empty-text">
          {{ 'charity_explorer.no_charities' | translateLang }}
        </p>
      </div>
    }
  </div>
</app-content-card>
